/**
 * 支付流程：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=472807223
 *
 * 提单异常处理逻辑：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=472807223
 * 1. 提单异常
 * 2. 提单异常响应逻辑
 *
 * 支付异常处理逻辑：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=182813871
 * 1. 支付异常
 * 2. 支付异常响应逻辑
 */

import { APP_INFO } from './base';
import config from '@/config';

function collectionToMap(collection, trans) {
  let map = {};
  Object.keys(collection).forEach(key => {
    let list = collection[key];
    list.forEach(value => {
      map[value] = trans(key);
    });
  });
  return map;
}

function transToNumber(value) {
  return Number(value);
}

/**
 * 提单异常响应逻辑
 */
export const SUBMIT_ORDER_ERROR_RESPONSE_TYPE = {
  // 弹窗并更新 riskControl
  PUP_RISK_UPDATE: 1,
  // 只弹窗，不更新 riskControl
  PUP_RISK_NO_UPDATE: 2,
  // 弹窗，”确认“后刷新提单页
  PUP_REFRESH: 3,
  // 只弹窗
  PUP: 4,
  // 弹窗 & 退出提单页
  PUP_CLOSE: 5,
  // 登录异常	跳转登陆
  LOGIN_ERR: 6,
  // etaConfirm 强制下单
  ETA_CONFIRM: 7,
  // 未成年提示
  UNDER_AGE: 8,
  // 重复下单提示
  ORDER_REPEAT: 9,
};

/**
 * 提单异常
 */
export const SUBMIT_ORDER_ERROR_RESPONSE_COLLECTION = {
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.PUP_RISK_UPDATE]: [
    100003,
    100004,
    100007,
    100008,
  ],
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.PUP_RISK_NO_UPDATE]: [
    41051,
    41053,
    41054,
    41055,
    41056,
    41057,
    41058,
    41059,
    41060,
  ],
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.PUP_REFRESH]: [
    40012, 40113, 40115, 41000, 41030, 41033, 41034,
    41010, 41011, 41012, 41013, 41014, 41015, 41020, 41021, 41022,
    41025, 41026, 41030, 41034, 41036, 41038, 41039, 41050,
    41080, 41090, 41092, 41043,
    41047, 44040, 44021, 44022, 44100, 45000, 45050, 45051, 45300,
    45303, 45307, 46251, 47200, 48201, 41091,
  ],
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.PUP]: [
    41033,
    41040,
    41045,
    41067,
    47101,
    47101,
    41026,
  ],
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.PUP_CLOSE]: [
    41031,
    41049,
  ],
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.LOGIN_ERR]: [
    50000,
    50001,
    50002,
    50003,
    50004,
    50005,
  ],
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.ETA_CONFIRM]: [
    41035,
    41042,
  ],
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.UNDER_AGE]: [
    41046,
  ],
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.ORDER_REPEAT]: [
    46900,
  ],
};

export const SUBMIT_ORDER_RESPONSE_ERROR_MAP = collectionToMap(
  SUBMIT_ORDER_ERROR_RESPONSE_COLLECTION, transToNumber);

/**
 * 支付异常响应逻辑
 */
export const PAY_ERROR_RESPONSE_TYPE = {
  // 内部错误，重试
  RETRY: 1,
  // 外部错误，弹窗提示后刷新提单页
  PUP_REFRESH: 2,
};

/**
 * 提单异常
 */
export const PAY_ERROR_RESPONSE_COLLECTION = {
  [PAY_ERROR_RESPONSE_TYPE.RETRY]: [
    -1,
    82019,
  ],
  [PAY_ERROR_RESPONSE_TYPE.PUP_REFRESH]: [
    900000,
    900001,
    900002,
    900003,
    900004,
    900005,
    900006,
    900007,
    900008,
    900008,
    900009,
    900010,
    900011,
    900012,
    900013,
    900014,
  ],
};

export const PAY_RESPONSE_ERROR_MAP = collectionToMap(
  PAY_ERROR_RESPONSE_COLLECTION, transToNumber);

export const PAY_SDK_CONFIG = {
  WEB_CHANNEL: '1300',
  DATA_TYPE: 130,
  APP_VERSION: APP_INFO.APP_VERSION,
};

// http://pay.intra.xiaojukeji.com/#techwiki/view/170
// 1 未支付；2 免密支付中；3 已支付；4 免密支付失败；5 线下支付；6 风控关单；7 已关单
export const PAY_STATUS = {
  NOT_PAY: 1,
  IN_PAY: 2,
  PAID: 3,
};

export const PAY_REQUEST_STATUS = {
  SUCCESS: 0,
  PARAMS_MISS: '81002',
};

export const PAY_CHANNEL_TYPE = {
  // Paypay 免密支付
  CHANNEL_PAYPAY: 182,
  // 99pay
  CHANNEL_WALLET: 190,
  // 现金支付
  CHANNEL_CASH: 153,
  // 在线支付
  CHANNEL_CREDIT_CARD: 150,
  // POS 机支付
  CHANNEL_POS: 154,
};

export const PAYMENT_QUERY_CALLBACK = {
  // 网络请求
  REQUEST_LEVEL: {
    isNetworkError(res) {
      // 网络异常
      return res.errno === config.constants.NETWORK_ERROR;
    },
    isParamsMissing(res) {
      // 缺少 transId
      return res.errno === PAY_REQUEST_STATUS.PARAMS_MISS;
    },
  },
  // 支付业务
  BUSINESS_LEVEL: {
    // 请求成功，request直接返回 res.data
    isParamsError(data) {
      // transId 取值异常
      return (
        data.pay_status === PAY_STATUS.NOT_PAY &&
        data.pay_status_detail === void 0
      );
    },
    isSuccess(data) {
      return data.pay_status === PAY_STATUS.PAID;
    },
    isTimeout(data) {
      return data.pay_status === PAY_STATUS.IN_PAY;
    },
    isFail(data) {
      return !this.isSuccess(data) && !this.isTimeout(data);
    },
  },
};
